define('plugin/invoice/view/InvoiceRecurringProfileListView',['require','lib/view/LayoutView','plugin/invoice/view/InvoiceRecurringProfileListCollectionView','lib/view/UnwrapRegion','lib/pager/view/PagerView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var InvoiceRecurringProfileListCollectionView = require('plugin/invoice/view/InvoiceRecurringProfileListCollectionView');
    var UnwrapRegion = require('lib/view/UnwrapRegion');
    var PagerView = require('lib/pager/view/PagerView');

    /**
     * invoice recurring profile layout view (profiles container)
     *
     * @class InvoiceRecurringProfileListView
     */
    return LayoutView.extend({

        template: '#invoice_recurring_profile_list_view',
        regions: {
            'list': {
                selector: '#sb_invoice_recurring_profile_list_container',
                regionClass: UnwrapRegion
            },
            'pager': '#sb_invoice_recurring_profile_pager_container'
        },

        onShow: function () {
            this.showChildView('list', new InvoiceRecurringProfileListCollectionView({
                collection: this.getOption('collection')
            }));
            this.showChildView('pager', new PagerView({
                pager: this.getOption('collection').getPager(),
                url: this.getOption('url')
            }));
        }

    });

});
